import crypto from "../assets/crypto.png";
import nike from "../assets/nike.png";
import RealEstate from "../assets/RealEstate.png";
import gym from "../assets/gym.png";
import Tenzies from "../assets/Tenzies.png";
import BBBY from "../assets/BBBY.png";

const projectCardData = [
  {
    imgsrc: RealEstate,
    title: "Real Estate Website",
    text: "I crafted a replica of a real estate website, employing the dynamic features of Framer Motion, Swiper for interactive carousels, an accordion component for organized content presentation.",
    view: "https://bkwilliamsmerncode.github.io/Real-Estate",
    source: "https://github.com/bkwilliamsmerncode/Real-Estate",
  },
  {
    imgsrc: gym,
    title: "Gym Exercises",
    text: "I integrated Rapid API's YouTube and Search services along with ExerciseDB to facilitate seamless searches for exercises. Providing instructional videos that demonstrate each exercise.",
    view: "https://bkwilliamsmerncode.github.io/gym-exercises-/",
    source: "https://github.com/bkwilliamsmerncode/gym-exercises-",
  },
  {
    imgsrc: crypto,
    title: "CryptoWorld",
    text: "I leveraged Rapid API's Cryptocurrency Database to conduct comprehensive searches for various cryptocurrencies available in the market. Also providing real-time updates on their values.",
    view: "https://bkwilliamsmerncode.github.io/crypto-currency/",
    source: "https://github.com/bkwilliamsmerncode/crypto-currency",
  },
  {
    imgsrc: nike,
    title: "Nike Clone Website",
    text: "I built this Nike clone website that links you to the real website using Vite and Tailwind.css, I used js files instead of real API's to simulate a full stack website.",
    view: "https://bkwilliamsmerncode.github.io/nike/",
    source: "https://github.com/bkwilliamsmerncode/nike",
  },
  {
    imgsrc: Tenzies,
    title: "Tenzies Game",
    text: "I meticulously developed an engaging and fully functional Tenzi game, employing React best practices such as useEffect, useState, uuid, and other strategic techniques.",
    view: "https://bkwilliamsmerncode.github.io/Tenzies/",
    source: "https://github.com/bkwilliamsmerncode/Tenzies",
  },
  {
    imgsrc: BBBY,
    title: "Yoga Website",
    text: "In this real world project I built a Web responsive Landing page for Dr. Donna Jagielski Yoga buisness using React best practices and dynamic features along with Email.js. ",
    view: "http://www.blessingsbalancebreathyoga.com/",
    source: "https://github.com/bkwilliamsmerncode/blessingsbalancebreathyoga",
  },
];

export default projectCardData;
